import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

/**
 * スクロールに応じて要素を「下から上に」現す共通処理
 *
 * @description [data-reveal] を持つ要素が画面下から入ってきたタイミングで
 *              少し下から上へスライドしながらフェードインさせる。
 *              data-reveal-delay で遅延（秒）を個別指定できる。
 *              ※ gsap.from を使うため、JSが動かない環境では要素はそのまま表示される。
 */

/** 動きを減らす設定のユーザーには適用しない */
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

/**
 * 1要素に「下から上に」のアニメーションを設定する
 * @param {HTMLElement} el - [data-reveal] を持つ要素
 */
const reveal = (el: HTMLElement): void => {
  const delay = Number(el.dataset.revealDelay ?? 0)

  gsap.from(el, {
    y: 64,
    autoAlpha: 0,
    duration: 0.9,
    delay,
    ease: "power3.out",
    scrollTrigger: {
      trigger: el,
      start: "top 88%",
      // once: true は使わない。ONにすると終端を通過した瞬間にトリガーが自分をkillして
      // ScrollTriggerの内部配列から抜けるため、フッター付近でページを読み込んだときに
      // 「上にある全トリガーが一斉にkill」→ ピン（.ach）の初期化がその配列を舐めている最中に
      // 添字がずれて ScrollTrigger.js が例外を投げ、以降の初期化ごと止まってしまう。
      // 既定の toggleActions（play none none none）だけで「1回再生・巻き戻さない」は満たせる。
    },
  })
}

if (!reduceMotion) {
  document.querySelectorAll<HTMLElement>("[data-reveal]").forEach(reveal)

  // 画像（遅延読み込み含む）が入って高さが変わるとトリガー位置がずれるため、
  // 読み込み完了後に再計算する。これをしないと要素が表示されないまま残ることがある。
  window.addEventListener("load", () => ScrollTrigger.refresh())
}

export { gsap, ScrollTrigger }
